var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHibernateDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "#242938"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.6162 38L110.238 97.9624L75.5993 158.009L41 97.9624L75.6162 38Z",
    fill: "#59666C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.871 38.0029H75.6357L110.258 97.9654H179.512L144.871 38.0029Z",
    fill: "#BCAE79"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M179.476 218L144.854 158.038L179.493 97.9907L214.092 158.038L179.476 218Z",
    fill: "#59666C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.221 217.995H179.465L144.871 158.033H75.5796L110.221 217.995Z",
    fill: "#BCAE79"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHibernateDark);
export default __webpack_public_path__ + "static/media/Hibernate-Dark.de26e847653cbb4b702ea2fba94df8e7.svg";
export { ForwardRef as ReactComponent };